module.exports = __webpack_public_path__ + "static/media/Sixty.37ad3bbe.ogg";